<template>
<div class="chapter">
<div class="inner_page">
<a id="p3"></a><h1 class="chaptertitle parttitle allcaps sans">Mac</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?2a36cfb1